const styles = (theme) => ({
  flexRow: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
  },
  searchRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    "&>div": {
      width: "100%",
    },
  },
});

export default styles;
